// extracted by mini-css-extract-plugin
export default {"external":"Modal_external__MYBVl"};